import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=0dc9091d&scoped=true&"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=0dc9091d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc9091d",
  null
  
)

export default component.exports